import * as React from 'react';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { Avatar, Rating, Typography } from '@mui/material';
import { PieChart } from 'react-minimal-pie-chart';
import CircleIcon from '@mui/icons-material/Circle';

interface OverallAllocationProps {
  availableResoureCount: number;
  allocatedResoureCount: number;
}

export const OverallAllocation: React.FC<OverallAllocationProps> = ({
  availableResoureCount,
  allocatedResoureCount
}) => {
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    width: 330,
    height: 500
  }));

  const Title = styled(Typography)(({ theme }) => ({
    padding: theme.spacing(1),
    textAlign: 'center',
    color: '#232C68',
    fontWeight: 'bold',
    marginTop: 4
  }));

  const StyledRating = styled(Rating)({});

  return (
    <>
      <Item>
        <Grid container>
          <Grid item>
            <Title>Overall Allocation</Title>
          </Grid>
          <Grid item>
            <Grid item sx={{ display: 'flex', flexDirection: 'column' }}>
              <Grid
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between'
                }}
              >
                <Grid sx={{ display: 'flex', flexDirection: 'row' }}>
                  <Grid style={{ width: '50%', marginLeft: 80 }}>
                    <PieChart
                      radius={50}
                      rounded
                      data={[
                        {
                          title: 'One',
                          value: allocatedResoureCount,
                          color: '#0069E4'
                        },
                        {
                          title: 'Two',
                          value: availableResoureCount,
                          color: '#5D9BE5'
                        }
                      ]}
                      lineWidth={40}
                    />
                  </Grid>
                  <Grid
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between'
                    }}
                  ></Grid>
                </Grid>
              </Grid>
              <Grid
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  pt: 1,
                  fontSize: 10,
                  justifyContent: 'space-around'
                }}
              >
                <Grid
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center'
                  }}
                >
                  <span
                    className="circle"
                    style={{ backgroundColor: '#5D9BE5' }}
                  ></span>
                  <span className="circle-text">
                    Available - {availableResoureCount}
                  </span>
                </Grid>
                <Grid
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center'
                  }}
                >
                  <span
                    className="circle"
                    style={{ backgroundColor: '#0069E4' }}
                  ></span>
                  <span className="circle-text">
                    Allocated - {allocatedResoureCount}
                  </span>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item sx={{ pt: 2 }}>
            <Title>Total Resouces</Title>
          </Grid>
        </Grid>
        <Grid
          item
          style={{
            display: 'flex',
            flexDirection: 'row'
          }}
        >
          <Avatar
            sx={{
              mt: '.75rem',
              ml: '.75rem',
              bgcolor: '#0069E4',
              width: 24,
              height: 24
            }}
          >
            5
          </Avatar>
          <StyledRating
            readOnly
            sx={{ ml: 1, mt: 2 }}
            name="customized-color"
            defaultValue={5}
            precision={1}
            icon={
              <CircleIcon
                style={{
                  fontSize: '18px',
                  color: '#0069E4',
                  marginLeft: '10px'
                }}
              />
            }
            emptyIcon={
              <CircleIcon
                style={{
                  fontSize: '18px',
                  color: '#C0C0C0',
                  marginLeft: '10px'
                }}
              />
            }
          />

          <Typography
            sx={{ mt: '.95rem', ml: '5rem', fontWeight: 'bold' }}
          ></Typography>
        </Grid>

        <Grid
          item
          style={{
            display: 'flex',
            flexDirection: 'row'
          }}
        >
          <Avatar
            sx={{
              mt: '.75rem',
              ml: '.75rem',
              bgcolor: '#00B26A',
              width: 24,
              height: 24
            }}
          >
            4
          </Avatar>
          <StyledRating
            readOnly
            sx={{ ml: 1, mt: 2 }}
            name="customized-color"
            defaultValue={4}
            precision={1}
            icon={
              <CircleIcon
                style={{
                  fontSize: '18px',
                  color: '#00B26A',
                  marginLeft: '10px'
                }}
              />
            }
            emptyIcon={
              <CircleIcon
                style={{
                  fontSize: '18px',
                  color: '#C0C0C0',
                  marginLeft: '10px'
                }}
              />
            }
          />
          <Typography
            sx={{ mt: '.95rem', ml: '5rem', fontWeight: 'bold' }}
          ></Typography>
        </Grid>

        <Grid
          item
          style={{
            display: 'flex',
            flexDirection: 'row'
          }}
        >
          <Avatar
            sx={{
              mt: '.75rem',
              ml: '.75rem',
              bgcolor: '#FFC107',
              width: 24,
              height: 24
            }}
          >
            3
          </Avatar>
          <StyledRating
            readOnly
            sx={{ ml: 1, mt: 2 }}
            name="customized-color"
            defaultValue={3}
            precision={1}
            icon={
              <CircleIcon
                style={{
                  fontSize: '18px',
                  color: '#FFC107',
                  marginLeft: '10px'
                }}
              />
            }
            emptyIcon={
              <CircleIcon
                style={{
                  fontSize: '18px',
                  color: '#C0C0C0',
                  marginLeft: '10px'
                }}
              />
            }
          />
          <Typography
            sx={{ mt: '.95rem', ml: '5rem', fontWeight: 'bold' }}
          ></Typography>
        </Grid>

        <Grid
          item
          style={{
            display: 'flex',
            flexDirection: 'row'
          }}
        >
          <Avatar
            sx={{
              mt: '.75rem',
              ml: '.75rem',
              bgcolor: '#FF7723',
              width: 24,
              height: 24
            }}
          >
            2
          </Avatar>
          <StyledRating
            readOnly
            sx={{ ml: 1, mt: 2 }}
            name="customized-color"
            defaultValue={2}
            precision={1}
            icon={
              <CircleIcon
                style={{
                  fontSize: '18px',
                  color: '#FF7723',
                  marginLeft: '10px'
                }}
              />
            }
            emptyIcon={
              <CircleIcon
                style={{
                  fontSize: '18px',
                  color: '#C0C0C0',
                  marginLeft: '10px'
                }}
              />
            }
          />
          <Typography
            sx={{ mt: '.95rem', ml: '5rem', fontWeight: 'bold' }}
          ></Typography>
        </Grid>

        <Grid
          item
          style={{
            display: 'flex',
            flexDirection: 'row'
          }}
        >
          <Avatar
            sx={{
              mt: '.75rem',
              ml: '.75rem',
              bgcolor: '#ED1C24',
              width: 24,
              height: 24
            }}
          >
            1
          </Avatar>
          <StyledRating
            readOnly
            sx={{ ml: 1, mt: 2 }}
            name="customized-color"
            defaultValue={1}
            precision={1}
            icon={
              <CircleIcon
                style={{
                  fontSize: '18px',
                  color: '#ED1C24',
                  marginLeft: '10px'
                }}
              />
            }
            emptyIcon={
              <CircleIcon
                style={{
                  fontSize: '18px',
                  color: '#C0C0C0',
                  marginLeft: '10px'
                }}
              />
            }
          />
          <Typography
            sx={{ mt: '.95rem', ml: '5rem', fontWeight: 'bold' }}
          ></Typography>
        </Grid>
      </Item>
    </>
  );
};

export default OverallAllocation;
